import { HttpClient } from '@angular/common/http';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly renderer: Renderer2;
  private themeLinkElement!: HTMLLinkElement;
  private currentTheme = 'light';

  private readonly chartPalettes: { [key: string]: string[] } = {
    light: ['#5e9cd3', '#ed7d31', '#70ad47', '#ffc000', '#4472c4', '#a5a5a5'],
    dark: ['#4bacc6', '#f79646', '#9bbb59', '#c0504d', '#772c77', '#5f5f5f'],
    contrast: ['#ff5722', '#9c27b0', '#2196f3', '#4caf50', '#ffeb3b', '#795548'],
  };
  constructor(
    private readonly rendererFactory: RendererFactory2,
    private readonly http: HttpClient,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.initializeThemeLinkElement();
  }

  private initializeThemeLinkElement() {
    const existing = document.getElementById('theme-link') as HTMLLinkElement | null;
    if (existing) {
      this.themeLinkElement = existing;
      // Keep theme stylesheet as the last head stylesheet so it overrides base/bootstrap styles.
      this.renderer.appendChild(document.head, this.themeLinkElement);
      return;
    }
    this.themeLinkElement = this.renderer.createElement('link');
    this.themeLinkElement.rel = 'stylesheet';
    this.themeLinkElement.id = 'theme-link';
    this.renderer.appendChild(document.head, this.themeLinkElement);
  }

  setTheme(theme: string) {
    const themeUrl = `assets/themes/${theme}-theme.css`;
    this.themeLinkElement.href = themeUrl;
    this.currentTheme = theme;
  }
  getCurrentTheme(): string {
    return this.currentTheme;
  }

  isDarkTheme(): boolean {
    return this.currentTheme.includes('dark');
  }

  getChartPalette(count: number): string[] {
    const palette = this.chartPalettes[this.currentTheme] || this.chartPalettes.light;
    return this.generatePalette(palette, count);
  }

  private generatePalette(baseColors: string[], count: number): string[] {
    const palette = [];
    for (let i = 0; i < count; i++) {
      palette.push(baseColors[i % baseColors.length]);
    }
    return palette;
  }
}
